import { getStorage } from 'src/utils/utils';

export default function getTokenAUTH(TOKEN_KEY) {
  return `Bearer ${getStorage(TOKEN_KEY)}`;
}
